import { _ as ie } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import { useTheme as je } from "@ucl/shared-component-foundations/themeProvider";
import { ThemeName as ke } from "@ucl/shared-component-foundations/themes";
import { fordProIcons as ce, creditIcons as fe } from "@ucl/shared-icons";
import { c as x } from "./index-8b07dec9.js";
import * as ze from "react";
import Le, { useContext as le, useMemo as H, useRef as ue, useState as we, useImperativeHandle as De, createElement as We, useEffect as Pe, useLayoutEffect as Ge, useCallback as Re } from "react";
import { useIsFirstRender as Fe } from "./useIsFirstRender.js";
import { usePagination as He } from "./usePagination.js";
import { useSlots as Qe } from "./useSlots.js";
import { u as xe } from "./useSwipe-7297d580.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import { _ as Ze } from "./cloneSlots-622cf8c9.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as qe } from "./getMetrics-953aa4f8.js";
import Q, { css as Z } from "styled-components";
import { Button as me } from "./button.js";
import { jsx as d, jsxs as de } from "react/jsx-runtime";
import "./es.symbol.description-6025a604.js";
import "./es.date.to-string-6ed49878.js";
import "./es.regexp.to-string-e800d529.js";
import "./export-cdcbfb2b.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./array-iteration-759bfbfa.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./useInterval.js";
import "./web.set-timeout-72b6430f.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.some-0c761b6d.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.object.keys-9d66766f.js";
import "./useEventListener.js";
import "./getTarget-19e0f923.js";
import "./isClient-2f5bedbd.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "@ucl/shared-component-foundations";
import "./combineRefs-c9ad2c39.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
var Se = /* @__PURE__ */ function(r) {
  return r.PROGRESS = "progress", r.SIMPLE = "simple", r;
}({}), v = /* @__PURE__ */ function(r) {
  return r.IDLE = "idle", r.COMPLETE = "complete", r.WARNING = "warning", r.ERROR = "error", r;
}({}), Oe = /* @__PURE__ */ function(r) {
  return r.HORIZONTAL = "horizontal", r.VERTICAL = "vertical", r;
}({}), ne = /* @__PURE__ */ ze.createContext({
  activeStep: 1,
  highestViewedStep: 1,
  type: Se.SIMPLE,
  stateIcons: {}
}), Je = /* @__PURE__ */ Q.div.withConfig({
  displayName: "progressTrackerstyles__ProgressTracker",
  componentId: "sc-1cbmdhl-0"
})(["&.ProgressTracker{", "}"], function(r) {
  var e = r.theme.components.progressTracker;
  return Z(e.ProgressTracker);
}), Ke = /* @__PURE__ */ Q.ul.withConfig({
  displayName: "progressTrackerstyles__Steps",
  componentId: "sc-1cbmdhl-1"
})(["&.ProgressTracker__steps{", ";}"], function(r) {
  var e = r.theme.components.progressTracker, i = r.stepCount;
  return Z(e.Steps, {
    "&--horizontal": {
      "--_tracker-step-count": i
    }
  });
}), Ue = /* @__PURE__ */ Q.div.withConfig({
  displayName: "progressTrackerstyles__HorizontalContent",
  componentId: "sc-1cbmdhl-2"
})(["&.ProgressStep__horizontal-content{", "}"], function(r) {
  var e = r.theme.components.progressTracker;
  return Z(e.HorizontalContent);
}), Xe = ["skipDisabled", "skipReadOnly", "skipComplete", "skipWarning", "skipError", "hidden", "className"], Ye = ["skipDisabled", "skipReadOnly", "skipComplete", "skipWarning", "skipError", "hidden", "className"], et = ["hidden", "className"], tt = function(e) {
  var i = e.skipDisabled, n = e.skipReadOnly, p = e.skipComplete, l = e.skipWarning, g = e.skipError, m = e.hidden, u = e.className, h = ie(e, Xe), C = le(ne), c = C.goToNextStep, y = C.activeStep, N = y === void 0 ? 1 : y, O = C.totalStep, E = O === void 0 ? 1 : O;
  return m ? null : /* @__PURE__ */ d(me, Object.assign({
    disabled: N > E
  }, h, {
    className: x(["ProgressTracker__next-step-button", u]),
    onClick: function(k) {
      c == null || c({
        skipDisabled: i,
        skipReadOnly: n,
        skipComplete: p,
        skipWarning: l,
        skipError: g
      }), h.onClick == null || h.onClick(k);
    }
  }));
}, rt = function(e) {
  var i = e.skipDisabled, n = e.skipReadOnly, p = e.skipComplete, l = e.skipWarning, g = e.skipError, m = e.hidden, u = e.className, h = ie(e, Ye), C = le(ne), c = C.goToPreviousStep, y = C.activeStep, N = y === void 0 ? 1 : y;
  return m ? null : /* @__PURE__ */ d(me, Object.assign({
    disabled: N <= 1
  }, h, {
    className: x(["ProgressTracker__previous-step-button", u]),
    onClick: function(E) {
      c == null || c({
        skipDisabled: i,
        skipReadOnly: n,
        skipComplete: p,
        skipWarning: l,
        skipError: g
      }), h.onClick == null || h.onClick(E);
    }
  }));
}, st = function(e) {
  var i = e.hidden, n = e.className, p = ie(e, et), l = le(ne), g = l.resetStep;
  return i ? null : /* @__PURE__ */ d(me, Object.assign({}, p, {
    className: x(["ProgressTracker__previous-reset-button", n]),
    onClick: function(u) {
      g == null || g(), p.onClick == null || p.onClick(u);
    }
  }));
}, ot = /* @__PURE__ */ Q.li.withConfig({
  displayName: "progressStepstyles__ProgressStep",
  componentId: "sc-1p6s4wi-0"
})(["&.ProgressStep{", "}"], function(r) {
  var e = r.theme.components.progressTracker;
  return Z(e.ProgressStep);
}), it = /* @__PURE__ */ Q.div.withConfig({
  displayName: "progressStepstyles__StepDotWrapper",
  componentId: "sc-1p6s4wi-1"
})(["&.ProgressStep__dot-wrapper{", "}"], function(r) {
  var e = r.theme.components.progressTracker;
  return Z(e.StepDotWrapper);
}), nt = /* @__PURE__ */ Q(me).withConfig({
  displayName: "progressStepstyles__StepDot",
  componentId: "sc-1p6s4wi-2"
})(["&.ProgressStep__dot{", "}"], function(r) {
  var e = r.theme.components.progressTracker;
  return Z(e.StepDot);
}), Ee = /* @__PURE__ */ Q.label.withConfig({
  displayName: "progressStepstyles__StepLabel",
  componentId: "sc-1p6s4wi-3"
})(["&.ProgressStep__label{", "}"], function(r) {
  var e = r.theme.components.progressTracker;
  return Z(e.StepLabel);
}), at = /* @__PURE__ */ Q.div.withConfig({
  displayName: "progressStepstyles__VerticalContent",
  componentId: "sc-1p6s4wi-4"
})(["&.ProgressStep__vertical-content{", "}"], function(r) {
  var e = r.theme.components.progressTracker;
  return Z(e.VerticalContent);
});
function pt(r) {
  var e = r._step, i = e === void 0 ? 1 : e, n = r.marker, p = r.state, l = r.disabled, g = r.readOnly, m = r.isHovered, u = le(ne), h = u.isSimpleStep, C = u.disableDefaultState, c = u.stateIcons, y = u.activeStep, N = y === void 0 ? 1 : y, O = u.highestViewedStep, E = O === void 0 ? 1 : O, q = u.totalStep, k = q === void 0 ? 1 : q, J = u.nonLinear, A = u.disableDefaultWarning, K = i - 1, j = i < N ? "pastStep" : i > N ? "futureStep" : "activeStep", a = j === "activeStep", b = j === "pastStep", re = j === "futureStep", $ = i <= E, se = i === 1, ae = i === k, V = !g && (J || a || b), s = !A && re && $, z = !!a || !!l || m && V, G = h ? typeof n == "string" ? n == null ? void 0 : n.substring(0, 2) : n : i, w = H(function() {
    if (C)
      return v.IDLE;
    if (s)
      return v.WARNING;
    if (b)
      return v.COMPLETE;
  }, [C, s, b]), D = H(function() {
    var B;
    return C ? p ?? v.IDLE : (B = p ?? w) != null ? B : v.IDLE;
  }, [w, C, p]), I = D === v.IDLE, L = D === v.COMPLETE, T = D === v.WARNING, U = D === v.ERROR, R = H(function() {
    return m && !a ? "default" : U ? "danger" : T ? "caution" : "default";
  }, [a, U, m, T]), ve = H(function() {
    return a || l ? (c == null ? void 0 : c.active) || G : m && V ? c == null ? void 0 : c.edit : L && b ? c == null ? void 0 : c[v.COMPLETE] : T && $ ? c == null ? void 0 : c[v.WARNING] : U && b ? c == null ? void 0 : c[v.ERROR] : G;
  }, [l, G, a, L, U, m, b, V, $, T, c]);
  return {
    stepIndex: K,
    stepProgress: j,
    isActiveStep: a,
    isPastStep: b,
    isViewedStep: $,
    isFutureStep: re,
    isFirstStep: se,
    isLastStep: ae,
    isStepClickable: V,
    isDirtyStep: s,
    isFilledStep: z,
    state: D,
    isIdle: I,
    isComplete: L,
    isWarning: T,
    isError: U,
    dotColor: R,
    dotContent: ve
  };
}
var lt = ["_step", "label", "markerText", "marker", "completed", "error", "state", "disabled", "readOnly", "onClick", "className", "children"], $e = /* @__PURE__ */ Le.forwardRef(function(e, i) {
  var n = e._step, p = n === void 0 ? 1 : n, l = e.label, g = e.markerText, m = e.marker, u = m === void 0 ? g : m, h = e.completed, C = e.error, c = e.state, y = c === void 0 ? C === !0 ? "error" : h === !0 ? "complete" : void 0 : c, N = e.disabled, O = e.readOnly, E = e.onClick, q = e.className, k = e.children, J = ie(e, lt), A = le(ne), K = A.type, j = K === void 0 ? Se.SIMPLE : K, a = A.isVerticalTracker, b = A.hideStepLabels, re = A.persistContent, $ = ue(null), se = we(!1), ae = se[0], V = se[1], s = pt({
    _step: p,
    marker: u,
    state: y,
    disabled: N,
    readOnly: O,
    isHovered: ae
  }), z = Object.assign({
    get container() {
      return $.current;
    },
    step: p,
    disabled: N,
    readOnly: O,
    label: l
  }, s);
  De(i, function() {
    return z;
  }, [z]);
  var G = H(function() {
    return k ? !s.isIdle || s.isActiveStep : !1;
  }, [k, s.isActiveStep, s.isIdle]), w = function() {
    return typeof k == "function" ? k(z) : [].concat(k).map(function(L) {
      return typeof L == "function" ? L(z) : L;
    });
  }, D = function() {
    return re ? /* @__PURE__ */ d("div", {
      style: {
        display: G ? "block" : "none"
      },
      className: x(["ProgressStep__content", {
        "ProgressStep__content--no-label": b || !l
      }]),
      children: w()
    }) : G ? /* @__PURE__ */ d("div", {
      className: x(["ProgressStep__content", {
        "ProgressStep__content--no-label": b || !l
      }]),
      children: w()
    }) : null;
  };
  return /* @__PURE__ */ de(ot, {
    ref: $,
    className: x(["ProgressStep", "ProgressStep--" + j, "ProgressStep--" + s.stepProgress, {
      "ProgressStep--vertical": a,
      "ProgressStep--firstStep": s.isFirstStep,
      "ProgressStep--lastStep": s.isLastStep
    }, q]),
    children: [/* @__PURE__ */ d(it, {
      className: x(["ProgressStep__dot-wrapper", "ProgressStep__dot-wrapper--" + s.stepProgress, "ProgressStep__dot-wrapper--" + s.state, {
        "ProgressStep__dot-wrapper--vertical": a,
        "ProgressStep__dot-wrapper--horizontal": !a,
        "ProgressStep__dot-wrapper--lastStep": s.isLastStep
      }]),
      children: /* @__PURE__ */ We(nt, Object.assign({
        "aria-label": s.state
      }, J, {
        key: Symbol(l || s.stepIndex).toString(),
        "aria-current": s.isActiveStep ? "step" : void 0,
        "data-step": p,
        "data-step-index": s.stepIndex,
        disabled: N,
        variant: s.isFilledStep ? "primary" : "secondary",
        color: s.dotColor,
        forwardedAs: s.isStepClickable ? "button" : "span",
        className: x(["ProgressStep__dot", "ProgressStep__dot--" + s.stepProgress, "ProgressStep__dot--" + s.state, {
          "ProgressStep__dot--clickable": s.isStepClickable,
          "ProgressStep__dot--viewedStep": s.isViewedStep
        }]),
        onMouseEnter: function() {
          return V(!0);
        },
        onMouseLeave: function() {
          return V(!1);
        },
        onClick: s.isStepClickable ? function(I) {
          return E == null ? void 0 : E(I, p);
        } : void 0
      }), s.dotContent)
    }), !a && !b && !!l && /* @__PURE__ */ d(Ee, {
      className: x(["ProgressStep__label", "ProgressStep__label--horizontal", "ProgressStep__label--" + s.stepProgress, {
        "ProgressStep__label--clickable": s.isStepClickable
      }]),
      children: l
    }), a && /* @__PURE__ */ de(at, {
      className: "ProgressStep__vertical-content",
      children: [!b && !!l && /* @__PURE__ */ d(Ee, {
        className: x(["ProgressStep__label", "ProgressStep__label--vertical", "ProgressStep__label--" + s.stepProgress, {
          "ProgressStep__label--clickable": s.isStepClickable
        }]),
        children: l
      }), D()]
    })]
  });
}), ct = ["stepProps"], ut = ["orientation", "type", "activeStep", "nonLinear", "readOnly", "hideStepLabels", "disableDefaultWarning", "disableContainerQuery", "disabledSwipeNavigation", "disableDefaultState", "animate", "animateStartOffset", "showScroll", "trackerVisible", "stateIcons", "persistContent", "className", "children", "onStepChange", "onNextStep", "onPreviousStep"], Ie = function(e) {
  var i = e.stepProps, n = ie(e, ct), p = n.skipDisabled && (i == null ? void 0 : i.disabled), l = n.skipReadOnly && (i == null ? void 0 : i.readOnly), g = n.skipComplete && (i == null ? void 0 : i.isComplete), m = n.skipWarning && (i == null ? void 0 : i.isWarning), u = n.skipError && (i == null ? void 0 : i.isError);
  return p || l || g || m || u;
}, he = function(e, i, n) {
  n == null || n({
    currentStep: e.currentPage,
    highestVisitedStep: e.highestVisitedPage,
    lastStep: e.lastPage,
    leastVisitedStep: e.leastVisitedPage,
    nextStep: e.nextPage,
    previousStep: e.previousPage,
    totalStep: e.totalPage,
    steps: i
  });
}, te = /* @__PURE__ */ Le.forwardRef(function(e, i) {
  var n = e.orientation, p = n === void 0 ? Oe.HORIZONTAL : n, l = e.type, g = l === void 0 ? Se.SIMPLE : l, m = e.activeStep, u = m === void 0 ? 1 : m, h = e.nonLinear, C = e.readOnly, c = e.hideStepLabels, y = e.disableDefaultWarning, N = y === void 0 ? !0 : y, O = e.disableContainerQuery, E = e.disabledSwipeNavigation, q = e.disableDefaultState, k = e.animate, J = e.animateStartOffset, A = e.showScroll, K = e.trackerVisible, j = K === void 0 ? !0 : K, a = e.stateIcons, b = e.persistContent, re = e.className, $ = e.children, se = e.onStepChange, ae = e.onNextStep, V = e.onPreviousStep, s = ie(e, ut), z = qe({
    label: "ProgressTracker"
  }), G = je(), w = G.themeName, D = Fe(), I = ue(null), L = ue(null), T = ue([]), U = H(function() {
    return g === Se.SIMPLE;
  }, [g]), R = H(function() {
    return p === Oe.VERTICAL;
  }, [p]), ve = Qe($, {
    TrackerSteps: te.ProgressStep
  }), B = Ze(ve.TrackerSteps.filter(function(t) {
    return !t.props.hidden;
  }), function(t, o) {
    var f;
    return /* @__PURE__ */ We(te.Step, Object.assign({
      onClick: function() {
        return M(o + 1);
      }
    }, t, {
      readOnly: (f = t.readOnly) != null ? f : C,
      key: t.label || o,
      _step: o + 1,
      ref: function(_) {
        return T.current[o] = _;
      }
    }));
  }), X = He({
    totalPage: B.length + 1,
    activePage: u,
    onPageChange: function(o) {
      return he(o, T.current, se);
    },
    onNextPage: function(o) {
      return he(o, T.current, ae);
    },
    onPreviousPage: function(o) {
      return he(o, T.current, V);
    }
  }), S = X.currentPage, Ce = X.canGoToNextPage, be = X.canGoToPreviousPage, M = X.goToPage, oe = X.totalPage, Ve = X.highestVisitedPage, Be = X.resetToStartPage;
  Pe(function() {
    D || M(u);
  }, [u]), Ge(function() {
    var t = I.current;
    if (t) {
      if (k && !R) {
        var o, f, P = (o = t.childNodes[S - 1]) == null ? void 0 : o.getBoundingClientRect().width, _ = (f = t.childNodes[S - 1]) == null ? void 0 : f.offsetLeft;
        t.style.top = "0px", t.style.marginTop = "0px", t.style.left = J || "calc(50% - " + P / 2 + "px)", t.style.marginLeft = "-" + _ + "px";
        return;
      }
      if (k && R) {
        var F, Y = (F = t.childNodes[S - 1]) == null ? void 0 : F.offsetTop;
        t.style.left = "0px", t.style.marginLeft = "0px", t.style.top = J || "25%", t.style.marginTop = "-" + Y + "px";
        return;
      }
      t.style.top = "0px", t.style.left = "0px", t.style.marginLeft = "0px", t.style.marginTop = "0px";
    }
  }, [S, k, J, R, oe]), Pe(function() {
    var t, o = I.current;
    !o || k || D || (t = o.childNodes[S - 1]) == null || t.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    });
  }, [S]);
  var _e = Re(function(t) {
    var o = t === void 0 ? {} : t, f = o.skipDisabled, P = f === void 0 ? !0 : f, _ = o.skipReadOnly, F = o.skipComplete, Y = o.skipWarning, pe = o.skipError, W = S + 1;
    if (!(P || _ || F || Y || pe))
      return M(W > oe ? S : W);
    for (; W <= oe && Ie({
      skipDisabled: P,
      skipReadOnly: _,
      skipComplete: F,
      skipWarning: Y,
      skipError: pe,
      stepProps: T.current[W - 1]
    }); )
      W += 1;
    M(W > oe ? S : W);
  }, [S, M, oe]), Te = Re(function(t) {
    var o = t === void 0 ? {} : t, f = o.skipDisabled, P = f === void 0 ? !0 : f, _ = o.skipReadOnly, F = _ === void 0 ? !0 : _, Y = o.skipComplete, pe = o.skipWarning, W = o.skipError, ee = S - 1;
    if (!(P || F || Y || pe || W))
      return M(ee < 1 ? S : ee);
    for (; ee >= 1 && Ie({
      skipDisabled: P,
      skipReadOnly: F,
      skipComplete: Y,
      skipWarning: pe,
      skipError: W,
      stepProps: T.current[ee - 1]
    }); )
      ee -= 1;
    M(ee < 1 ? S : ee);
  }, [S, M]), Me = H(function() {
    var t, o, f, P, _;
    return _ = {
      active: a == null ? void 0 : a.active,
      edit: (t = a == null ? void 0 : a.edit) != null ? t : /* @__PURE__ */ d(ce.Edit, {})
    }, _[v.COMPLETE] = (o = a == null ? void 0 : a[v.COMPLETE]) != null ? o : w === ke.FORD_PRO ? /* @__PURE__ */ d(ce.Checkmark, {}) : /* @__PURE__ */ d(fe.Checkmark, {}), _[v.WARNING] = (f = a == null ? void 0 : a[v.WARNING]) != null ? f : w === ke.FORD_PRO ? /* @__PURE__ */ d(ce.Warning, {}) : /* @__PURE__ */ d(fe.Warning, {}), _[v.ERROR] = (P = a == null ? void 0 : a[v.COMPLETE]) != null ? P : w === ke.FORD_PRO ? /* @__PURE__ */ d(ce.CancelClose, {}) : /* @__PURE__ */ d(fe.CancelClose, {}), _;
  }, [a, w]), ge = {
    type: g,
    activeStep: S,
    totalStep: oe - 1,
    nonLinear: h,
    hideStepLabels: c,
    disableDefaultWarning: N,
    isSimpleStep: U,
    isVerticalTracker: R,
    disableDefaultState: q,
    highestViewedStep: Ve,
    stateIcons: Me,
    persistContent: b,
    goToNextStep: _e,
    goToPreviousStep: Te,
    goToStep: M,
    resetStep: Be
  };
  De(i, function() {
    return Object.assign({}, ge, {
      get steps() {
        var t;
        return (t = T.current) == null ? void 0 : t.filter(Boolean);
      },
      canGoToNextStep: Ce,
      canGoToPreviousStep: be
    });
  }, [Ce, be, ge]), xe("onSwipeLeft", function() {
    return _e();
  }, !E && L), xe("onSwipeRight", function() {
    return Te();
  }, !E && L);
  var ye = we({}), Ne = ye[0], Ae = ye[1];
  return Pe(function() {
    Ae(T.current[S - 1] || {});
  }, [S]), /* @__PURE__ */ d(ne.Provider, {
    value: ge,
    children: /* @__PURE__ */ de(Je, Object.assign({
      className: x(["ProgressTracker", "ProgressTracker--" + g, {
        "ProgressTracker--vertical": R,
        "ProgressTracker--horizontal": !R,
        "ProgressTracker--nonLinear": h,
        "ProgressTracker--animate": k,
        "ProgressTracker--disableContainerQuery": O
      }, re])
    }, z, s, {
      children: [/* @__PURE__ */ d(Ke, {
        "data-step-count": B.length,
        stepCount: B.length,
        ref: I,
        className: x(["ProgressTracker__steps", {
          "ProgressTracker__steps--vertical": R,
          "ProgressTracker__steps--horizontal": !R,
          "ProgressTracker__steps--nonLinear": h,
          "ProgressTracker__steps--animate": k,
          "ProgressTracker__steps--overflow": !k && !R && A
        }]),
        children: B
      }), !R && B.map(function(t, o) {
        var f = o === S - 1;
        return !b && !f ? null : /* @__PURE__ */ de(Ue, {
          style: {
            display: f ? "block" : "none"
          },
          className: "ProgressStep__horizontal-content",
          children: [!c && !!t.props.label && /* @__PURE__ */ d("label", {
            className: "ProgressStep__content-label",
            children: t.props.label
          }), j && /* @__PURE__ */ d("span", {
            className: "ProgressStep__content-text",
            children: "Step " + S + " of " + B.length
          }), !!t.props.children && /* @__PURE__ */ d("div", {
            ref: L,
            className: "ProgressStep__content",
            children: typeof t.props.children == "function" ? t.props.children(Ne) : [].concat(t.props.children).map(function(P) {
              return typeof P == "function" ? P(Ne) : P;
            })
          })]
        }, t.props.label);
      })]
    }))
  });
});
te.ProgressStep = $e;
te.Step = $e;
te.NextStepButton = tt;
te.PreviousStepButton = rt;
te.ResetStepButton = st;
export {
  v as ProgressStepState,
  te as ProgressTracker,
  Oe as ProgressTrackerOrientation,
  Se as ProgressTrackerType
};
